import styled from "styled-components";

export const GrayDiv = styled.div`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 1.2rem;
`;

export const AuxiliarContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const EmptyResult = styled.span`
  ${({ theme }) => `
    color: ${theme.colors.gray};
  `}
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
`;

export const FlexJustifyBetween = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .buttom-download {
    background: #ffffff;
    color: #2e353d;
    height: 6.3rem;
    margin-right: 1.8rem;
    width: 26rem;
  }
  .flex-item-center {
    align-items: center;
    display: flex;
  }
  .buttom-claim-register {
    background: #88b13b;
    color: #ffffff;
    height: 6.3rem;
    width: 34.3rem;
  }
`;

export const DivFlexButton = styled.div`
  display: flex;
  @media (max-width: 750px) {
    align-items: center;
    flex-direction: column;
  }
`;

export const DivFlexComplaint = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
  @media (max-width: 750px) {
    flex-direction: column;
  }
`;
